"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTERS = void 0;
var FILTERS = [{
  name: "All"
}, {
  name: "Goal",
  category: "Description",
  type: "key",
  tag_name: "goal",
  sport_type: "soccer"
}, {
  name: "Touch Chain",
  category: "Description",
  type: "touch chain",
  tag_name: "touch-chain",
  sport_type: "soccer"
}, {
  name: "Progression",
  category: "Description",
  type: "packing",
  tag_name: "packing",
  tag_side: "home",
  sport_type: "soccer"
}, {
  name: "Att ⅓",
  category: "Location",
  third: "offensive",
  tag_name: "offensive",
  sport_type: "soccer"
}, {
  name: "Mid ⅓",
  category: "Location",
  third: "middle",
  tag_name: "middle",
  sport_type: "soccer"
}, {
  name: "Def ⅓",
  category: "Location",
  third: "defensive",
  tag_name: "defensive",
  sport_type: "soccer"
}, {
  name: "Box",
  category: "Description",
  type: "home-box",
  tag_name: "home-box",
  sport_type: "soccer"
}, {
  name: "Opponent Box",
  category: "Description",
  type: "away-box",
  tag_name: "away-box",
  sport_type: "soccer"
}, {
  name: "Defensive Breakdown",
  category: "Description",
  type: "away-packing",
  tag_name: "packing",
  tag_side: "away",
  sport_type: "soccer"
}, {
  name: "Touch",
  category: "Description",
  type: "touch",
  tag_name: "touch",
  sport_type: "soccer"
}, {
  name: "Dive",
  category: "Description",
  type: "dive",
  tag_name: "dive",
  sport_type: "soccer"
}, {
  name: "Hit",
  category: "Description",
  tag_name: "hit",
  sport_type: "baseball"
}, {
  name: "Single",
  category: "Description",
  tag_name: "single",
  sport_type: "baseball"
}, {
  name: "Double",
  category: "Description",
  tag_name: "double",
  sport_type: "baseball"
}, {
  name: "Triple",
  category: "Description",
  tag_name: "triple",
  sport_type: "baseball"
}, {
  name: "Homerun",
  category: "Description",
  tag_name: "homerun",
  sport_type: "baseball"
}, {
  name: "Pitcher",
  category: "Description",
  tag_name: "pitcher",
  sport_type: "baseball"
}, {
  name: "Out",
  category: "Description",
  tag_name: "out",
  sport_type: "baseball"
}];
exports.FILTERS = FILTERS;